import React, {createRef} from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import ApiPerformingTaskMessage from '../../components/message/ApiPerformingTaskMessage';
import PlainPage, {FORM_STATE_INIT_ERROR} from '../../components/plain/PlainPage';
import LabelField from '../../components/plain/LabelField';
import FieldString from '../../components/plain/FieldString';
import FieldInteger from '../../components/plain/FieldInteger';
import FieldDecimal from '../../components/plain/FieldDecimal';
import FieldDatetime from '../../components/plain/FieldDatetime';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldRefList from '../../components/plain/FieldRefList';
import FieldList_TableEntity from '../../components/plain/FieldList_TableEntity';
import EBookReportItemPlainModal from './EBookReportItemPlainModal';


import {getCurrentResource, formatDateTime} from '../../util/tools';
import {FORM_EBOOK_REPORT_PLAIN, FORM_EBOOK_SUPPLIER_TABLE, FORM_EBOOK_REPORT_ITEM_ENTITY_T, FORM_PRODUCT_TABLE} from '../../util/consts/forms';
import {EBOOK_SUPPLIER_PLAIN_PATH, PRODUCT_PLAIN_PATH} from '../../util/routes';
import {
	performApiRequest, ACTION_EBOOK_REPORT_GET_SUPPLIER_API_URL, ENTITY_LOAD_API_URL,
	ACTION_EBOOK_REPORT_DELETE_ITEMS_API_URL
} from '../../util/restapi'; 
import {IET_SET_VALUE} from '../../util/realm/instance';
import {isSuperUser} from '../../util/localStorage';

class EBookReportEntityTablePlainPage extends PlainPage {

	resourceReportPage = null;
	refSupplierNodes = [
		{
			classId: 'EBookSupplier', plainFormPath: EBOOK_SUPPLIER_PLAIN_PATH, 
			selectInstanceFormId: FORM_EBOOK_SUPPLIER_TABLE,
			selectInstanceFormTitle: 'Розповсюджувач'
		}
	];
	
	readOnly = false;
	
	constructor(props) {
		super(props);
		this.plainId = FORM_EBOOK_REPORT_PLAIN + '_entity';
		this.formPath = FORM_EBOOK_REPORT_PLAIN;
		this.formTitle = 'Звіт розповсюджувача за програмою "єКнига"';
		this.refItemsTable = createRef();
		this.refDeleteItemsModal = createRef();
		this.refQty = createRef();
		this.refAmount = createRef();
		this.resourceReportPage = getCurrentResource().pages.plain.EBookReportPlainPage;
	}
	componentDidMount = async () => {
		this.init('EBookReport')
		document.title = 'BOM. ' + this.formTitle;
	}
	completeInit = async () => {
		this.readOnly = this.instanceReadOnly;
		if( this.instance ) {
			let state = this.instance.rootField.value.state.value;
			if( state == 'accepted' && ! isSuperUser() )
				this.readOnly = true;
		}
		let beanSupplier = null;
		if( this.instance.id == null ) {
			this.instance.rootField.value.dateTime.value = formatDateTime( new Date() );
			let supplierRequest = {
				type: 'initial'
			}
			let response = await performApiRequest(ACTION_EBOOK_REPORT_GET_SUPPLIER_API_URL, supplierRequest);
			if( ! response.success ) {
				this.setState({formState: FORM_STATE_INIT_ERROR, message: response.message});
				return false;
			}
			beanSupplier = response.data;
			if( beanSupplier != null ) {
				let refSupplier = {
					id: beanSupplier.id,
					globalId: beanSupplier.globalId,
					className: beanSupplier.className,
					card: beanSupplier.cardMaster
				};
				this.instance.rootField.value.supplierRef.value = refSupplier;
			} 
		} else {
			let supplierRef = this.instance.rootField.value.supplierRef.value;
			if( supplierRef != null ) {
				let response = await performApiRequest(ENTITY_LOAD_API_URL, supplierRef); //{id: supplierRef.id});
				if( ! response.success ) {
					this.setState({formState: FORM_STATE_INIT_ERROR, message: response.message});
					return false;
				}
				beanSupplier = response.data;
			}
		}
		this.state.supplier = beanSupplier;
		this.state.isSupplierRefReadOnly = this.instance.rootField.value.reportItem.value.length > 0;
		return true;
	}
	// Override
	createBeanFromInstance(instance) {
		let bean = instance.createBean();
		bean.reportItem = null;
		return bean;
	}
	
	handleInstanceChange = async (event) => {
		super.handleInstanceChange(event);
		let field = event.field;
		
		let fieldRefSupplier = this.instance.rootField.value.supplierRef;
		let beanSupplier = null;
		if( event.eventType == IET_SET_VALUE && field == fieldRefSupplier ) {
			let supplierRef = fieldRefSupplier.value;
			if( supplierRef != null ) {
				let response = await performApiRequest(ENTITY_LOAD_API_URL, supplierRef);
				if( response.success ) {
					beanSupplier = response.data;
				}
			}
			this.setState({supplier: beanSupplier})
		}

		this.setState({
			isSupplierRefReadOnly: this.instance.rootField.value.reportItem.value.length > 0,
			plainDirtyCounter: this.state.plainDirtyCounter + 1 
		});
		
	}

	deleteReportItems = async (listId) => {
		let request = {
			listId: listId,
		}
		return await performApiRequest(ACTION_EBOOK_REPORT_DELETE_ITEMS_API_URL, request);
	}
	
	createReportItemPlain = (table, indexBean, bean) => {
		return (
			<EBookReportItemPlainModal table={table} masterPlain={this} indexBean={indexBean} bean={bean} 
				supplier={this.state.supplier} 
			/>
		);
	}
	renderBody() {
		let res = this.resourceReportPage;
		let instance = this.state.instance;
		
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<div style={{display: 'flex', alignItems: 'center'}}>
						<FieldRefList instance={instance} path={'/supplierRef'} plain={this}
							readOnly={this.state.isSupplierRefReadOnly || this.readOnly}
							styles={{divMain: {flexGrow: '1', marginRight: '20px'}}}
						/>
					</div>
					{/*
					<div style={{display: 'flex', alignItems: 'center'}}>
						<FieldReference instance={instance} path={'/supplierRef'} plain={this}
							refNodes={this.refSupplierNodes}
							readOnly={this.state.isSupplierRefReadOnly || this.readOnly}
							styles={{divMain: {flexGrow: '1', marginRight: '20px'}}}
						/>
					</div>
					*/}
					<div style={{ display: 'flex', marginTop: '15px',alignItems: 'center'}}>
						<FieldDatetime instance={instance} path={'/dateTime'} plain={this} 
							readOnly={this.readOnly}
							styleInput={{width: '200px', marginRight: '20px'}} 
						/>
						<FieldEnum instance={instance} path={'/year'} plain={this} 
							readOnly={this.readOnly}
							styles={{ select: {flexGrow: '0', marginRight: '20px'}}}
						/>
						<FieldEnum instance={instance} path={'/month'} plain={this} 
							readOnly={this.readOnly}
							styles={{ select: {flexGrow: '0', marginRight: '20px'}}}
						/>
						<FieldInteger ref={this.refQty} instance={instance} path={'/qty'} plain={this} 
							readOnly={true}
							styleInput={{width: '60px', textAlign: 'right', marginRight: '20px'}} 
						/>
						<FieldDecimal ref={this.refAmount} instance={instance} path={'/amount'} plain={this} 
							readOnly={true}
							styleInput={{width: '100px', textAlign: 'right', marginRight: '20px'}} 
						/>
						<FieldEnum instance={instance} path={'/state'} plain={this} 
							readOnly={ ! isSuperUser() }
							styles={{ select: {flexGrow: '0'}}}
						/>
					</div>
					<div style={{marginTop: '20px'}}>
						<FieldList_TableEntity ref={this.refItemsTable}
							formId={FORM_EBOOK_REPORT_ITEM_ENTITY_T} 
							instance={instance}
							readOnly={this.readOnly}
							columnCard={{ 
								columnId: 'productRef',
								refNodes: [
									{
										classId: 'Product', plainFormPath: PRODUCT_PLAIN_PATH, 
										selectInstanceFormId: FORM_PRODUCT_TABLE,
										selectInstanceFormTitle: 'Продукт'
									}
								]
							}}
							table={{
								columns: [
									{ columnId: 'dateTime', styles: {tdHeader: {width: '17%'} } }, 
									{ columnId: 'ps', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'aid', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'mid', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'mcc', styles: {tdHeader: {width: '7%'} } },
									{ columnId: 'tid', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'bin', styles: {tdHeader: {width: '12%'} } },
									{ columnId: 'operation', styles: {tdHeader: {width: '10%'} } },
									{ columnId: 'tranId', styles: {tdHeader: {width: '8%'} } },
									{ columnId: 'qty', styles: {tdHeader: {width: '2%'}, dataComponent: { textAlign: 'right'} } },  
									{ columnId: 'price', styles: {tdHeader: {width: '4%'}, dataComponent: { textAlign: 'right'} } },
								],
							}}
							deleteMarkedRows={this.deleteReportItems}
							modal={{
								title: res.modalTitle,
								createModalForm: this.createReportItemPlain,
							}}
						/>
					</div>					
					<div style={{marginTop: '20px', paddingRight: '9px'}}>
						<div>
							<LabelField instance={this.state.instance} path={'/comment'} />
						</div>
						<div>
							<FieldString instance={this.state.instance} path={'/comment'} plain={this}
								multiline={true} rows={5} cols={60} styles={{input: {width: '100%'}}}
								readOnly={this.readOnly}
							 />
						</div>
					</div>			
				</div>
				<ApiPerformingTaskMessage ref={this.refDeleteItemsModal} 
					title={'DELETE'} message={'Deleting marked items'} maxWidth={500}
					doAfterClose={this.completeDeleteReportItems}
				/>
			</div>
		)
	}
}

export default EBookReportEntityTablePlainPage;
